/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VideoStatusOverview { 
    processing?: number;
    queued?: number;
    completed?: number;
    error?: number;
    total?: number;
}

